export enum AccountComponent {
    APP_SIGN_IN = "APP_SIGN_IN",
    IDENTITY_PROVIDER = "IDENTITY_PROVIDER",
    REGIONAL = "REGIONAL"
}